import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import Radio from '@material-ui/core/Radio';
import colors from 'config/colors';

// The chosen report of a Reports tab, kept in the browser so a reload (or coming back later) lands on the same one. Only a key that is
// still offered counts; storage that is blocked just means it starts from the default every time.
export const usePersistedReport = (storageKey, items, fallback) => {
  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      return items.some(item => item.key === saved) ? saved : fallback;
    } catch (err) {
      return fallback;
    }
  });
  const change = key => {
    setValue(key);
    try {
      localStorage.setItem(storageKey, key);
    } catch (err) {
      // not saved: the choice still works for this visit
    }
  };
  return [value, change];
};

// "Which report?" as a row of radio cards (icon, title, one line of what it shows), the same on every Reports tab. items are
// { key, label, icon, description }; the chosen one is outlined and tinted.
const ReportPicker = ({ items, value, onChange }) => (
  <Row className="mb-2">
    {items.map(item => {
      const checked = value === item.key;
      return (
        <Col key={item.key} lg md={6} xs={12} className="mb-2">
          <div
            role="radio"
            aria-checked={checked}
            tabIndex={0}
            onClick={() => onChange(item.key)}
            onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onChange(item.key)}
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 4,
              padding: '10px 12px',
              borderRadius: 8,
              border: `1.5px solid ${checked ? colors.accent : '#e0e0e0'}`,
              backgroundColor: checked ? '#F5EDFB' : '#fff',
              cursor: 'pointer',
            }}>
            <Radio checked={checked} size="small" style={{ color: colors.accent, padding: 2, marginTop: -2 }} />
            <div>
              <div style={{ fontWeight: 'bold', fontSize: 13 }}>
                <i className={item.icon} style={{ marginRight: 6, color: colors.accent }} />
                {item.label}
              </div>
              <div style={{ fontSize: 12, color: '#6b778a', marginTop: 2 }}>{item.description}</div>
            </div>
          </div>
        </Col>
      );
    })}
  </Row>
);

export default ReportPicker;
